import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/np/Seo";
import SectionHeading from "@/components/np/SectionHeading";
import Hero from "@/components/home/Hero";
import TrustStrip from "@/components/home/TrustStrip";
import FinalCta from "@/components/home/FinalCta";
import { DoctorSection, TreatmentsCompact, WhatWeTreat } from "@/components/home/Sections";
import BodyAreaExplorer from "@/components/body/BodyAreaExplorer";
import ProcessSteps from "@/components/treatments/ProcessSteps";
import FaqList from "@/components/treatments/FaqList";
import ClinicCard from "@/components/clinics/ClinicCard";
import { clinics, meta, site } from "@/content";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  name: site.name,
  telephone: "+46-8-99 35 23",
  email: site.email.display,
  address: { "@type": "PostalAddress", streetAddress: "Forumvägen 14", postalCode: "131 53", addressLocality: "Nacka", addressCountry: "SE" },
  medicalSpecialty: "PainMedicine",
};

export default function Home() {
  return (
    <>
      <Seo {...meta.home} jsonLd={jsonLd} />
      <Hero />
      <TrustStrip />
      <section id="var-har-du-ont" className="scroll-mt-28 py-16 sm:py-20 lg:py-24" aria-labelledby="body-title">
        <div className="container-np">
          <SectionHeading id="body-title" eyebrow="Var har du ont?" title="Börja där det gör ont" intro="Välj ett område så ser du vilka besvär vi arbetar med där och vilka behandlingar som kan vara aktuella." />
          <div className="mt-8 lg:mt-10"><BodyAreaExplorer /></div>
        </div>
      </section>
      <WhatWeTreat />
      <DoctorSection />
      <section className="py-16 sm:py-20 lg:py-24" aria-labelledby="process-title">
        <div className="container-np">
          <SectionHeading id="process-title" eyebrow="Så går det till" title="Från bedömning till uppföljning" intro="Varje behandling bygger på en läkarbedömning och en plan som anpassas efter dig." />
          <div className="mt-10"><ProcessSteps /></div>
        </div>
      </section>
      <TreatmentsCompact />
      <section className="section bg-sand/60" aria-labelledby="clinics-title">
        <div className="container-np">
          <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <SectionHeading id="clinics-title" eyebrow="Mottagningar" title="Nacka och Göteborg" intro="Samma läkare, två mottagningar. Välj den som passar dig bäst." />
            <Link to="/kliniker-boka" data-testid="clinics-page-link" className="link-arrow">Priser & bokning <ArrowRight className="h-4 w-4" /></Link>
          </div>
          <div className="mt-12 grid gap-5 md:grid-cols-2">
            {clinics.map((c) => <ClinicCard key={c.id} clinic={c} />)}
          </div>
        </div>
      </section>
      <section className="py-16 sm:py-20 lg:py-24" aria-labelledby="faq-title">
        <div className="container-np grid gap-10 lg:grid-cols-12">
          <SectionHeading id="faq-title" className="lg:col-span-4" eyebrow="Vanliga frågor" title="Bra att veta innan du bokar" />
          <div className="lg:col-span-8"><FaqList limit={5} /></div>
        </div>
      </section>
      <FinalCta />
    </>
  );
}
